import React from 'react';
import { useNavigate } from 'react-router-dom';
import './../common.css'; // Import common CSS styles

function DevOpsToolsPage() {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleCICDClick = () => {
    window.open('https://nj6v-devops-04.crestron.crestron.com/DefaultCollection/XioTerraform/_build?view=folders', '_blank');
  };

  const handleMonitoringClick = () => {
    window.open('https://crestroneng.atlassian.net/jira/ops/alerts?view=list&query=', '_blank');
  };

  const handleInfrastructureClick = () => {
    window.open('https://nj-github.crestron.crestron.com/CrestronEngineering/CloudOperations', '_blank');
  };

  const handleJiraBoardClick = () => {
    window.open('https://crestroneng.atlassian.net/jira/software/c/projects/ESOPS/boards/639', '_blank');
  };

  const handleOpsIntelClick = () => {
    window.open('https://crestroneng.atlassian.net/wiki/spaces/OPSCTR/overview?homepageId=10846648', '_blank');
  };

  const handleSWFlowDiagramsClick = () => {
    window.open('https://crestroneng.atlassian.net/wiki/spaces/ESOPS/pages/15597603/Software+Flows', '_blank');
  };

  const handlePowerBIClick = () => {
    window.open('https://app.powerbi.com/browse/recent?experience=power-bi', '_blank');
  };

  const handleSecOpsClick = () => {
    window.open('https://crestroneng.atlassian.net/wiki/spaces/XIOCLD/pages/1959460871/SecOps+Deliverables', '_blank');
  };

  const handleXiODeploymentDashboardClick = () => {
    window.open('https://portal.azure.com/#@mycrestron.onmicrosoft.com/dashboard/arm/subscriptions/fe611e36-9acb-4477-9bda-80c3141abca9/resourcegroups/dashboards/providers/microsoft.portal/dashboards/e2e6f019-8d70-4584-be41-0ad99c4a76ab', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-800 via-blue-900 to-slate-900 flex flex-col">
      {/* Main Content - Centered Vertically */}
      <div className="flex-1 flex flex-col items-center justify-center px-8">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-6xl font-bold text-white mb-4 drop-shadow-lg">
            DevOps Tools
          </h1>
          <h2 className="text-2xl font-semibold text-cyan-300 mb-6 drop-shadow-lg">
            Development and Operations Management
          </h2>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-7xl mx-auto mb-12">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">CI/CD Pipeline</h3>
            <p className="text-gray-200 text-xs mb-3">
              Continuous Integration and Deployment tools - Azure DevOps
            </p>
            <button 
              onClick={handleCICDClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Monitoring</h3>
            <p className="text-gray-200 text-xs mb-3">
              System monitoring and alerting dashboard - OpsGenie
            </p>
            <button 
              onClick={handleMonitoringClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">PowerBI Dashboards</h3>
            <p className="text-gray-200 text-xs mb-3">
              Business intelligence and analytics dashboards
            </p>
            <button 
              onClick={handlePowerBIClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Infrastructure</h3>
            <p className="text-gray-200 text-xs mb-3">
              Infrastructure as Code management - Git Repository
            </p>
            <button 
              onClick={handleInfrastructureClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">XiO Dashboards</h3>
            <p className="text-gray-200 text-xs mb-3">
              XiO deployment monitoring and management dashboards
            </p>
            <button 
              onClick={handleXiODeploymentDashboardClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">SecOps</h3>
            <p className="text-gray-200 text-xs mb-3">
              Security operations and compliance documentation
            </p>
            <button 
              onClick={handleSecOpsClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">OpsIntel</h3>
            <p className="text-gray-200 text-xs mb-3">
              OpsCenter Confluence documentation
            </p>
            <button 
              onClick={handleOpsIntelClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Jira Board</h3>
            <p className="text-gray-200 text-xs mb-3">
              Project management and issue tracking - Jira Board
            </p>
            <button 
              onClick={handleJiraBoardClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">SW Flow Diagrams</h3>
            <p className="text-gray-200 text-xs mb-3">
              Software flow documentation and diagrams
            </p>
            <button 
              onClick={handleSWFlowDiagramsClick}
              className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm"
            >
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Test-1</h3>
            <p className="text-gray-200 text-xs mb-3">
              Test tool for development purposes
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Test-2</h3>
            <p className="text-gray-200 text-xs mb-3">
              Test tool for development purposes
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Test-3</h3>
            <p className="text-gray-200 text-xs mb-3">
              Test tool for development purposes
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Tool-4</h3>
            <p className="text-gray-200 text-xs mb-3">
              Additional development tool
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Tool-5</h3>
            <p className="text-gray-200 text-xs mb-3">
              Additional development tool
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Tool-6</h3>
            <p className="text-gray-200 text-xs mb-3">
              Additional development tool
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 text-center hover:bg-white/20 transition-all duration-300">
            <h3 className="text-lg font-semibold text-cyan-300 mb-2">Tool-7</h3>
            <p className="text-gray-200 text-xs mb-3">
              Additional development tool
            </p>
            <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-3 py-1.5 rounded-lg transition-colors text-sm">
              Access
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DevOpsToolsPage;
